import { Box, Flex, HStack, Text, useColorModeValue } from '@chakra-ui/react'
import { BaseTooltip } from '.'
import type { GraphLegendItem } from './GraphLegends.types'

type LegendItemProps = GraphLegendItem

const LegendIcon = ({ lineColor, iconType = 'line' }: Pick<LegendItemProps, 'lineColor' | 'iconType'>) => {
  if (iconType === 'dashed-line') {
    return (
      <Flex gap='3px' alignItems='center' flexShrink={0} pt={'2px'}>
        <Box w='5px' h='3px' bg={lineColor} borderRadius='1px' />
        <Box w='5px' h='3px' bg={lineColor} borderRadius='1px' />
      </Flex>
    )
  }
  return (
    <Box
      w={iconType === 'box' ? '12px' : '14px'}
      h={iconType === 'box' ? '12px' : '3px'}
      bg={lineColor}
      borderRadius={iconType === 'box' ? '3px' : 0}
    />
  )
}

const LegendItem = ({ text, tooltipText, lineColor, iconType }: LegendItemProps) => {
  const textColor = useColorModeValue('gray.800', 'white')
  return (
    <HStack spacing={2}>
      <LegendIcon lineColor={lineColor} iconType={iconType} />
      <Flex align='center' gap={1}>
        <Text textAlign='center' mt='2px' fontSize='sm' color={textColor}>
          {text}
        </Text>
        {tooltipText && <BaseTooltip width={'16px'} height={'16px'} label={tooltipText} />}
      </Flex>
    </HStack>
  )
}

interface GraphLegendsProps {
  legends: GraphLegendItem[]
}

export const GraphLegends = ({ legends }: GraphLegendsProps) => {
  return (
    <Flex wrap='wrap' gap={6}>
      {legends.map(legend => (
        <LegendItem
          key={legend.text}
          text={legend.text}
          tooltipText={legend.tooltipText}
          lineColor={legend.lineColor}
          iconType={legend.iconType}
        />
      ))}
    </Flex>
  )
}
